<template>
  <div class="taxed-money-input">
    <div class="value-input">
      <div class="value">
        <MoneyInput :currency.sync="currencySelected"
                    :value.sync="valueInput"
                    :precision="precision"
                    :default-value="defaultValue"
                    :disable-currency="disableCurrency"
                    @on-change="handleEmit">
        </MoneyInput>
      </div>
      <div class="has-tax-checkbox">
        <Checkbox v-model="taxedSelected" @on-change="handleChangeTaxed">{{ $t('taxed') }}</Checkbox>
      </div>
      <InputNumber v-model="taxRateInput" @on-change="handleEmit"></InputNumber>
      <!-- <Input v-model="taxRateInput" type="number" @on-change="handleEmit"></Input> -->
    </div>
  </div>
</template>

<script>
import MoneyInput from './money'
export default {
  name: 'MoneyWithTaxed',
  components: {
    MoneyInput
  },
  props: {
    currency: {
      type: String,
      required: false
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    defaultValue: {
      type: Number,
      required: false
    },
    taxed: {
      type: Boolean,
      required: false,
      default: true
    },
    taxRate: {
      type: [Number, String],
      default: 0.13
    },
    precision: {
      type: Number,
      default: 2
    },
    disableCurrency: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted () {
    if (this.defaultValue) {
      this.valueInput = this.defaultValue * 1
    }
  },
  data() {
    return {
      valueInput: this.value,
      currencySelected: this.currency,
      taxedSelected: this.taxed,
      taxRateInput: Number(this.taxRate),
      notTaxedValue: this.taxedSelected
        ? this.defaultValue
        : Math.round(this.defaultValue / (1 + this.taxRateInput) * Math.pow(10, this.precision)) / Math.pow(10, this.precision),
      taxedValue: this.taxedSelected
        ? Math.round(this.defaultValue * (1 + this.taxRateInput) * Math.pow(10, this.precision)) / Math.pow(10, this.precision)
        : this.defaultValue
    }
  },
  watch: {
    value: function (newVal) {
      if (newVal !== this.valueInput) {
        this.valueInput = newVal
      }
    },
    taxed: function (newVal) {
      this.taxedSelected = newVal
    },
    currency: function (newVal) {
      this.currencySelected = newVal
    },
    taxRate: function (newVal) {
      this.taxRateInput = Number(newVal)
    }
  },
  methods: {
    handleEmit: function () {
      let powLength = Math.pow(10, this.precision)
      this.taxedValue = this.taxedSelected
        ? Math.round(this.valueInput * (1 + this.taxRateInput) * powLength) / powLength
        : this.valueInput
      this.notTaxedValue = this.taxedSelected
        ? this.valueInput
        : Math.round(this.valueInput / (1 + this.taxRateInput) * powLength) / powLength
      this.$emit('on-change', { value: this.valueInput, currency: this.currencySelected, price_has_tax: this.taxedSelected, tax_rate: this.taxRateInput })
    },
    handleChangeTaxed () {
      this.$emit('on-change', { value: this.valueInput, currency: this.currencySelected, price_has_tax: this.taxedSelected, tax_rate: this.taxRateInput })
    }
  }
}
</script>

<style lang="less" scoped>
.taxed-money-input {
  .value-input {
    display: flex;
    width: 350px;
    align-items: center;
    justify-content: space-between;
    .value {  min-width: 200px; }
    .has-tax-checkbox {  min-width: 65px; display: block; margin-left: 10px}
    label {
      font-weight: normal;
    }
  }
}
</style>
